import { CodedError } from './coded-error';

export class UnauthorizedError extends CodedError {
    public override name = UnauthorizedError.name;

    public constructor(
        public override readonly message = 'Unauthorized access.',
        data?: unknown,
    ) {
        super(message, 'UNAUTHORIZED', data);
    }
}
